export const validateRequireSpecialSymbols = (value: string): boolean => {
  return /[\@\#\$\%\^\&\;\:\*\_\-\+\=\!\?\[\]\{\}\/\\\.\,\<\>]/.test(value);
};
